import * as React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Base.css';
const VerifyCheckVerificationAdopted = () => {
    const selectVerifyCheckState = (state) => state.verifyCheck;
    const verifyCheckState = useSelector(selectVerifyCheckState);
    const dispatch = useDispatch();
    const verifyCheck = useSelector((state) => state.verifyCheck);
    const processStateAction = (x) => ({ type: 'GOTO_PROCESS_STATE', processState: x });
    const submitData = (e) => {
        dispatch(processStateAction(e.currentTarget.value));
    };
    return React.createElement("div", null,
        React.createElement("div", null, "Already Adopted"),
        React.createElement("div", null,
            "This AutoCheck has already been adopted.",
            React.createElement("br", null),
            "If you believe this to be in error, please contact Support."),
        React.createElement("div", null,
            "Credit Union Contact Info:",
            React.createElement("br", null),
            verifyCheck ? verifyCheck.siteDraft.loanOfficerName : "",
            React.createElement("br", null),
            verifyCheck ? verifyCheck.siteDraft.loanOfficerEmail : "",
            React.createElement("br", null),
            verifyCheck ? verifyCheck.siteDraft.loanOfficerPhone : "",
            React.createElement("br", null),
            verifyCheck ? verifyCheck.siteDraft.loanOfficerFax : "",
            React.createElement("br", null)),
        React.createElement("div", { className: "button_container" },
            React.createElement("button", { className: "btn btn-primary", name: "btnTryAgain", value: "start", onClick: submitData }, "Try Again")));
};
export default VerifyCheckVerificationAdopted;
//# sourceMappingURL=VerifyCheckVerificationAdopted.js.map